import React, {useEffect, useState} from 'react';
import {sortBy} from 'lodash';
import Dropdown from 'src/components/dropdown';
import Label from 'shared/components/label';
import PropTypes from 'prop-types';
import {setFromTargetValue} from '../../../utils/form';

const propTypes = {
  educationPhases: PropTypes.arrayOf(PropTypes.string),
  fetchUniversities: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  autoSelectFirstUniversity: PropTypes.bool,
  hideLabel: PropTypes.bool,
};

const UniversityDropdown = (props) => {
  const [universities, setUniversities] = useState([]);
  const universityOptions = universities.map(({id, name}) => ({_id: id, value: id, text: name}));
  const {onChange, value, disabled, fetchUniversities} = props;

  useEffect(() => {
    fetchUniversities(props.educationPhases).then((responseUniversities) => {
      const sortedUniversities = sortBy(responseUniversities, ['name']);
      setUniversities(sortedUniversities);

      if (props.autoSelectFirstUniversity && sortedUniversities[0] && !value) {
        onChange(sortedUniversities[0].id);
      }
    });
  }, [(props.educationPhases || []).join(',')]);

  if (props.hideLabel) {
    return (
      <Dropdown
        name="sponsorId"
        options={universityOptions}
        onChange={setFromTargetValue(onChange)}
        value={value}
        disabled={disabled}
      />
    );
  }

  return (
    <Label>
      University
      <Dropdown
        name="sponsorId"
        options={universityOptions}
        onChange={setFromTargetValue(onChange)}
        value={value}
        disabled={disabled}
      />
    </Label>
  );
};

UniversityDropdown.propTypes = propTypes;
export default UniversityDropdown;
